import { RouteRecordRaw } from "vue-router";
import MainLayout from "@/layouts/MainLayout.vue";
import EmptyLayout from "@/layouts/EmptyLayout.vue";

export enum RouteNames {
  EMPTY_LAYOUT = "EmptyLayout",
  LOGIN_VIEW = "LoginView",
  BLOCKED_VIEW = "BlockView",
  MAIN_LAYOUT = "MainLayout",
  HOME_VIEW = "HomeView",
  NOT_FOUND = "NotFound",
  PRODUCTS_PARAMS = "ProductsParams",
  ORDERS_VIEW = "OrderView",
  PVZ_VIEW = "PvzView",
  ADMIN_VIEW = "AdminView",
  MARKETING_VIEW = "MarketingView",
  ORDERS_LIST = "OrdersList",
  ORDERS_COURIER_REQUESTS = "OrdersCourierRequests",
  PRODUCTS_CATALOG = "ProductsCatalog",
  PRODUCTS_STORAGE = "ProductsStorage",
  PRODUCTS_CREATE = "ProductsCreate",
  PARAMS_CATEGORY = "ParamsCategory",
  PARAMS_BRANDS = "ParamsBrands",
  PARAMS_COLOR = "ParamsColor",
  PARAMS_OTHERS = "ParamsOthers",
  PARAMS_CATALOG_LIST = "ParamsCatalogList",
  PARAMS_VARIANTS_LIST = "ParamsVariantsList",
  STORAGE_BALANCE = "StorageBalance",
  STORAGE_HISTORY = "StorageHistory",
  STORAGE_MANAGE = "StorageManage",
}

export const RoutePaths: Record<RouteNames, string> = {
  [RouteNames.EMPTY_LAYOUT]: "/login",
  [RouteNames.BLOCKED_VIEW]: "/blocked",
  [RouteNames.PRODUCTS_PARAMS]: "/params",
  [RouteNames.LOGIN_VIEW]: "",
  [RouteNames.MAIN_LAYOUT]: "/",
  [RouteNames.HOME_VIEW]: "",
  [RouteNames.NOT_FOUND]: "/:pathMatch(.*)",
  [RouteNames.ORDERS_VIEW]: "/orders",
  [RouteNames.PVZ_VIEW]: "/pvz",
  [RouteNames.ADMIN_VIEW]: "/admins",
  [RouteNames.MARKETING_VIEW]: "/marketing",
  [RouteNames.ORDERS_LIST]: "/orders",
  [RouteNames.ORDERS_COURIER_REQUESTS]: "/orders/requests",
  [RouteNames.PRODUCTS_CATALOG]: "/catalog",
  [RouteNames.PRODUCTS_STORAGE]: "/storage",
  [RouteNames.PRODUCTS_CREATE]: "/product/create",
  [RouteNames.PARAMS_CATEGORY]: "category",
  [RouteNames.PARAMS_BRANDS]: "brands",
  [RouteNames.PARAMS_COLOR]: "colors",
  [RouteNames.PARAMS_OTHERS]: "others",
  [RouteNames.PARAMS_CATALOG_LIST]: "/catalog",
  [RouteNames.PARAMS_VARIANTS_LIST]: "/catalog/variants",
  [RouteNames.STORAGE_BALANCE]: "/storage",
  [RouteNames.STORAGE_HISTORY]: "/storage/history",
  [RouteNames.STORAGE_MANAGE]: "/storage-manage",
};

export const routes: RouteRecordRaw[] = [
  {
    path: RoutePaths[RouteNames.EMPTY_LAYOUT],
    name: RouteNames.EMPTY_LAYOUT,
    component: EmptyLayout,
    children: [
      {
        path: RoutePaths[RouteNames.LOGIN_VIEW],
        name: RouteNames.LOGIN_VIEW,
        component: () => import("@/views/auth/AuthPage.vue"),
      },
      {
        path: RoutePaths[RouteNames.BLOCKED_VIEW],
        name: RouteNames.BLOCKED_VIEW,
        component: () => import("@/views/blocked/BlockedPage.vue"),
      },
    ],
  },
  {
    path: RoutePaths[RouteNames.MAIN_LAYOUT],
    name: RouteNames.MAIN_LAYOUT,
    component: MainLayout,
    children: [
      {
        path: RoutePaths[RouteNames.PRODUCTS_PARAMS],
        name: RouteNames.PRODUCTS_PARAMS,
        component: () => import("@/views/products/ProductsParams.vue"),
        children: [
          {
            path: RoutePaths[RouteNames.PARAMS_CATEGORY],
            name: RouteNames.PARAMS_CATEGORY,
            component: () =>
              import(
                "@/modules/productPage/pages/productsCategories/ParamsCategory.vue"
              ),
          },
          {
            path: RoutePaths[RouteNames.PARAMS_BRANDS],
            name: RouteNames.PARAMS_BRANDS,
            component: () =>
              import(
                "@/modules/productPage/pages/productsBrands/ParamsBrands.vue"
              ),
          },
          {
            path: RoutePaths[RouteNames.PARAMS_COLOR],
            name: RouteNames.PARAMS_COLOR,
            component: () =>
              import(
                "@/modules/productPage/pages/productsParams/ProductsColors.vue"
              ),
          },
          {
            path: RoutePaths[RouteNames.PARAMS_OTHERS],
            name: RouteNames.PARAMS_OTHERS,
            component: () =>
              import(
                "@/modules/productPage/pages/productsParams/ProductsParams.vue"
              ),
          },
        ],
      },
      {
        path: RoutePaths[RouteNames.PRODUCTS_CATALOG],
        name: RouteNames.PRODUCTS_CATALOG,
        component: () => import("@/views/products/ProductsCatalog.vue"),
        children: [
          {
            path: RoutePaths[RouteNames.PARAMS_CATALOG_LIST],
            name: RouteNames.PARAMS_CATALOG_LIST,
            component: () =>
              import(
                "@/modules/productPage/pages/productsCatalog/ProductsCatalog.vue"
              ),
          },
          {
            path: RoutePaths[RouteNames.PARAMS_VARIANTS_LIST],
            name: RouteNames.PARAMS_VARIANTS_LIST,
            component: () =>
              import(
                "@/modules/productPage/pages/productsCatalog/VariantsCatalog.vue"
              ),
          },
        ],
      },
      {
        path: RoutePaths[RouteNames.PRODUCTS_CREATE],
        name: RouteNames.PRODUCTS_CREATE,
        component: () => import("@/views/products/ProductCreate.vue"),
      },
      {
        path: RoutePaths[RouteNames.PRODUCTS_STORAGE],
        name: RouteNames.PRODUCTS_STORAGE,
        component: () => import("@/views/products/ProductsStorage.vue"),
        children: [
          {
            path: RoutePaths[RouteNames.STORAGE_BALANCE],
            name: RouteNames.STORAGE_BALANCE,
            component: () =>
              import(
                "@/modules/productPage/pages/productsStorage/StorageBalance.vue"
              ),
          },
          {
            path: RoutePaths[RouteNames.STORAGE_HISTORY],
            name: RouteNames.STORAGE_HISTORY,
            component: () =>
              import(
                "@/modules/productPage/pages/productsStorage/StorageHistory.vue"
              ),
          },
        ],
      },
      {
        path: RoutePaths[RouteNames.STORAGE_MANAGE],
        name: RouteNames.STORAGE_MANAGE,
        component: () =>
          import(
            "@/modules/productPage/pages/productsStorage/StorageManage.vue"
          ),
      },
      {
        path: RoutePaths[RouteNames.ORDERS_VIEW],
        name: RouteNames.ORDERS_VIEW,
        component: () => import("@/views/orders/OrdersPage.vue"),
        children: [
          {
            path: RoutePaths[RouteNames.ORDERS_LIST],
            name: RouteNames.ORDERS_LIST,
            component: () => import("@/modules/orders/pages/OrdersList.vue"),
          },
          {
            path: RoutePaths[RouteNames.ORDERS_COURIER_REQUESTS],
            name: RouteNames.ORDERS_COURIER_REQUESTS,
            component: () =>
              import("@/modules/orders/pages/OrdersCourierRequests.vue"),
          },
        ],
      },
      {
        path: RoutePaths[RouteNames.PVZ_VIEW],
        name: RouteNames.PVZ_VIEW,
        component: () => import("@/views/pvz/PvzPage.vue"),
      },
      {
        path: RoutePaths[RouteNames.ADMIN_VIEW],
        name: RouteNames.ADMIN_VIEW,
        component: () => import("@/views/admins/AdminsPage.vue"),
      },
      {
        path: RoutePaths[RouteNames.MARKETING_VIEW],
        name: RouteNames.MARKETING_VIEW,
        component: () => import("@/views/marketing/MarketingPage.vue"),
      },
    ],
  },
  {
    path: RoutePaths[RouteNames.NOT_FOUND],
    name: RouteNames.NOT_FOUND,
    component: () => import("@/views/NotFoundPage.vue"),
  },
];
